var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade"}},[_c('CookieAlert')],1),_c('BaseHeader'),_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{staticClass:"router-view-layout"})],1),_c('BaseFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }